<template>
  <div>
    <WizardQuestion
      :title="
        getComponentUiText(
          'app-component-wizards-setup-wizard-brands-page-title-1',
        )
      "
      :description="
        getComponentUiText(
          'app-component-wizards-setup-wizard-brands-page-sub-title-1',
        )
      "
    >
      <WizardRadioQuestion
        :title="
          getComponentUiText(
            'app-component-wizards-setup-wizard-brands-page-question-1',
          )
        "
        :required="true"
        :answer="isBrandName"
        @on-update="checkYesNo"
      />
      <div
        v-if="isApiError && statusInPage.errorMessage"
        class="tw-bg-[#FEE5E2] tw-px-[12px] tw-py-[8px] tw-flex tw-items-center tw-mt-[25px] tw-rounded-[6px] tw-gap-[10px]"
      >
        <WarningIcon color="#F7553C" />
        <p
          class="tw-text-[#F7553C] tw-text-[11px] tw-font-[500] tw-leading-[130%] tw-text-center tw-mb-[0px]"
        >
          {{
            getComponentUiText(
              "app-component-wizards-setup-error-tooltip",
              false,
              {
                errorMessage: statusInPage.errorMessage
                  ? ensurePeriod(statusInPage.errorMessage)
                  : "",
              },
            )
          }}
        </p>
      </div>
      <div v-if="currentValue">
        <p class="tw-mb-[25px] tw-pt-[37px] tw-leading-[100%]">
          <span class="tw-text-[#231F20] tw-text-[14px] tw-font-medium">{{
            getComponentUiText(
              "app-menu-submenu-home-setup-wizard-brand-details-note-1",
            )
          }}</span>
        </p>
        <div v-for="(item, index) in brands" :key="item.id">
          <listBrand
            ref="listBrandRef"
            :item="item"
            :current-index="index"
            :data="{ item: item, index: index }"
            :status-in-page="statusInPage"
            @change-status-add-brand="
              emits('onUpdate', $event), checkAllValidations
            "
          />
        </div>
        <ButtonAddAnother style-button="tw-mt-0" @click="addAnother">
          {{
            getComponentUiText(
              "app-menu-submenu-home-setup-wizard-brand-add-another-button-1",
            )
          }}
        </ButtonAddAnother>
      </div>
    </WizardQuestion>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, watch, Ref } from "vue";
import ButtonAddAnother from "./buttonAddAnother.vue";
import { ensurePeriod, getComponentUiText } from "@/utils/utilities";
import WizardQuestion from "./wizardQuestion.vue";
import WizardRadioQuestion from "./wizardRadioQuestion.vue";
import store from "@/store";
import listBrand from "./listBrand.vue";
import WarningIcon from "../svgs/warningIcon.vue";
import { statusPage } from "@/utils/constants";
const currentOrg = computed(() => store.state.Org.currentOrg);
onMounted(() => {
  store.commit("SetupWizard/SET_CURRENT_ORG", currentOrg.value.id);
});

const listBrandRef: any = ref([]);
const props = defineProps({
  isApiError: {
    type: Boolean,
    required: false,
    default: false,
  },
  statusInPage: {
    type: Object,
    default: () => ({
      statusPage: statusPage.NotChange,
      dataError: [],
    }),
  },
});
watch(
  props.statusInPage,
  (value) => {
    if (
      value.statusPage === statusPage.CallApi ||
      value.statusPage === statusPage.Error
    ) {
      brands.value = brands.value.map((item) => {
        item.isCallAPI = true;
        return item;
      });
    }
  },
  { deep: true },
);

const accordionNumber = computed(() => {
  const setupWizard = store.state.SetupWizard;
  if (
    setupWizard.questions[currentOrg.value.id]?.brands[0]?.values.length > 0
  ) {
    return setupWizard.questions[currentOrg.value.id].brands[0].values.map(
      (el) => ({
        ...el,
        showAccordion: false,
      }),
    );
  } else {
    return [];
  }
});
const brands: Ref<any> = ref(accordionNumber);
const isBrandName = computed(() => {
  const setupWizard = store.state.SetupWizard;
  if (setupWizard.questions[currentOrg.value.id]?.brands[0]?.values) {
    const isBrandName = setupWizard.questions[
      currentOrg.value.id
    ].brands[0].values.some((item) => item.id && !item.isArchived);
    return isBrandName ? 1 : "";
  } else {
    return "";
  }
});
const checkAllValidations = async () => {
  let isAllValid = true,
    listServices = [] as any[];
  for (let index = 0; index < listBrandRef.value.length; index++) {
    const test = await listBrandRef.value[index].saveChanges();
    if (!test) {
      isAllValid = false;
    }
    listServices.push(test.finalValue);
  }
  return isAllValid;
};
const emits = defineEmits([
  "onUpdate",
  "update:answer",
  "changeStatusAddBrand",
]);
const currentValue = ref(0);
const checkYesNo = (value) => {
  currentValue.value = value;
  emits("onUpdate", value);
};

const addAnother = () => {
  const objAdd = {
    brandName: "",
    domainRegistrarId: null,
    domainRegistrar: null,
    startDate: new Date(),
    description: null,
    notes: null,
    endDate: null,
    showAccordion: false,
    isArchived: false,
  };
  accordionNumber.value.forEach((item) => (item.showAccordion = false));
  store.commit("SetupWizard/SET_BRAND_NAME_PUSH", {
    objAdd,
    currentOrg: currentOrg.value.id,
  });
};
defineExpose({
  checkAllValidations,
});
</script>
<style scoped>
::placeholder {
  color: #b7b7b7;
  font-size: 14px;
  font-family: Poppins;
  font-weight: 400;
}
.enter__name {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px;
  font-family: Poppins;
  color: #211f58;
  width: 98%;
}
::-ms-input-placeholder {
  color: red;
}
@media screen and (max-width: 590px) {
  .enter__name {
    width: 100%;
  }
}
</style>
